import { render } from "./update-base-factor.vue?vue&type=template&id=6c4c246c&scoped=true"
import script from "./update-base-factor.vue?vue&type=script&lang=js"
export * from "./update-base-factor.vue?vue&type=script&lang=js"

import "./update-base-factor.vue?vue&type=style&index=0&id=6c4c246c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4c246c"],['__file',"src/components/applications/wagesetting/update/update-base-factor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4c246c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4c246c', __exports__)) {
    api.reload('6c4c246c', __exports__)
  }
  
  module.hot.accept("./update-base-factor.vue?vue&type=template&id=6c4c246c&scoped=true", () => {
    api.rerender('6c4c246c', render)
  })

}


export default __exports__